import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import 'chart.js/auto';
import { Bar, getElementAtEvent } from 'react-chartjs-2';

import { request, reportErrorToHoneybadger } from '../../../helpers/Requests'

import EventsPanel from '../../../components/shared/EventsPanel';

import { capitalize } from '../../../utilities/Forms.js'

import SlidingPane from "../../../components/shared/ScrollableSlidingPane";

class AnalysisFeedbackByTimeOfDay extends Component {
  static TIMES_OF_DAY = ["morning", "afternoon", "evening", "night"];
  static TYPES = ["positive", "neutral", "negative"];

  constructor(props) {
    super(props);

    this.barGraph = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.openPanel = this.openPanel.bind(this);
  }

  handleClick(event) {
    // do not try to open events panel when charts are not being clicked
    if (getElementAtEvent(this.barGraph.current, event)[0] === undefined) {
      return
    }

    const timeOfDayIndex = getElementAtEvent(this.barGraph.current, event)[0].index
    const typeIndex = getElementAtEvent(this.barGraph.current, event)[0].datasetIndex
    this.openPanel(timeOfDayIndex, typeIndex)
  }

  openPanel(timeOfDayIndex, typeIndex) {
    const type = AnalysisFeedbackByTimeOfDay.TYPES[typeIndex]
    const timeOfDay = AnalysisFeedbackByTimeOfDay.TIMES_OF_DAY[timeOfDayIndex]

    this.setState({
      infoPanel: true,
      timeOfDay: timeOfDay,
      type: type
    })
    this.props.history.push(`/analysis/overview/${timeOfDay}/${type}${this.props.location.search}`)
  }

  render() {
    const { json, loaded, error, unauthorized, invalid_params, infoPanel, type, timeOfDay } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (invalid_params === true) {
      return <p>Waiting for valid date range ...</p>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {

      const data = {
        labels: json.map(array => (capitalize(array.time_of_day))),
        datasets: [{
          label: "Positive",
          data: json.map((array) => ( array.positive.length )),
          backgroundColor: '#22ee80'
        }, {
          label: "Neutral",
          data: json.map((array) => ( array.neutral.length )),
          backgroundColor: '#eee622'
        }, {
          label: "Negative",
          data: json.map((array) => ( array.negative.length )),
          backgroundColor: '#ce5252'
        }]
      }

      const options = {
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          yAxes: {
            stacked: true,
            ticks: {
              beginAtZero: true,
            }
          },
          xAxes: {
            stacked: true,
          }
        }
      }

      return (
        <div className="widget">
          <h3>Feedback by Time of Day</h3>
          <Bar className="link" data={data} width={500} height={300} options={options} ref={this.barGraph} onClick={this.handleClick} />

          <SlidingPane isOpen={infoPanel} title={type && `${capitalize(type)} Events - ${capitalize(timeOfDay)}`} width="70%"
            onRequestClose={() => {
              this.setState({
                infoPanel: false,
                type: null
              });
              this.props.history.push(`/analysis/overview${this.props.location.search}`)
            }}>
            <EventsPanel event_ids={json.find(records => records.time_of_day === timeOfDay)?.[type]}></EventsPanel>
          </SlidingPane>
        </div>
      );
    }
  }

  state = {
    json: [],
    infoPanel: false,
    timeOfDay: null,
    type: null,
    loaded: false,
    error: null,
    unauthorized: null,
    invalid_params: false
  };

  static getDerivedStateFromProps(props, state) {
    const validContext = AnalysisFeedbackByTimeOfDay.TYPES.includes(props.match.params.context)
    const validChart = AnalysisFeedbackByTimeOfDay.TIMES_OF_DAY.includes(props.match.params.chart)

    if (state.infoPanel === false && validChart && validContext) {
      return {
        infoPanel: true,
        timeOfDay: props.match.params.chart,
        type: props.match.params.context
      }
    }
    else if (state.infoPanel && (validChart === false || validContext === false)) {
      return {
        infoPanel: false,
        timeOfDay: null,
        type: null
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && validChart && validContext) {
      return {
        infoPanel: true,
        timeOfDay: props.match.params.chart,
        type: props.match.params.context
      }
    }
    else if (props.history.action === "POP" && (validChart === false || validContext === false)) {
      return {
        infoPanel: false,
        timeOfDay: null,
        type: null
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    if (this.props.date_from !== "" && this.props.date_to !== "") {
      let params = `analysis[date_from]=${this.props.date_from}&analysis[date_to]=${this.props.date_to}&analysis[location]=${this.props.location_id}`

      request('GET', `/v1/a/analysis/feedback_by_time_of_day?${params}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({ json: data, loaded: true })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }
    else {
      this.setState({
        invalid_params: true
      })
    }
  }
}

export default withRouter(AnalysisFeedbackByTimeOfDay);
